module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "entity-property"
    }
  }, [_c('div', {
    staticClass: "md-layout-row header"
  }, [(_vm.property) ? _c('div', {
    staticClass: "md-flex"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    attrs: {
      "to": {
        name: 'Entity',
        params: {
          code: _vm.$route.params.code,
          entity_code: _vm.$route.params.entity_code
        },
        query: _vm.$route.query
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1), _c('md-field', [_c('label', [_vm._v("Название")]), _c('md-input', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.name),
      callback: function($$v) {
        _vm.$set(_vm.property, "name", $$v)
      },
      expression: "property.name"
    }
  })], 1), _c('md-field', [_c('label', [_vm._v("Символьный код")]), _c('md-input', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.code),
      callback: function($$v) {
        _vm.$set(_vm.property, "code", $$v)
      },
      expression: "property.code"
    }
  })], 1), _c('md-field', [_c('label', [_vm._v("Сортировка")]), _c('md-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.sort),
      callback: function($$v) {
        _vm.$set(_vm.property, "sort", $$v)
      },
      expression: "property.sort"
    }
  })], 1), (Object.keys(_vm.entities).length) ? _c('md-field', [_c('label', [_vm._v("Сущность")]), _c('md-select', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.field_entity),
      callback: function($$v) {
        _vm.$set(_vm.property, "field_entity", $$v)
      },
      expression: "property.field_entity"
    }
  }, _vm._l((_vm.entities), function(entity) {
    return _c('md-option', {
      key: entity.code,
      attrs: {
        "value": entity.code
      }
    }, [_vm._v(_vm._s(entity.name))])
  }))], 1) : _vm._e(), _c('md-field', [_c('label', [_vm._v("Тип свойства")]), _c('md-select', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.field_type),
      callback: function($$v) {
        _vm.$set(_vm.property, "field_type", $$v)
      },
      expression: "property.field_type"
    }
  }, _vm._l((_vm.propertyTypes), function(propertyType) {
    return _c('md-option', {
      key: propertyType.code,
      attrs: {
        "value": propertyType.code
      }
    }, [_vm._v(_vm._s(propertyType.name))])
  }))], 1), _c('md-field', [_c('label', [_vm._v("Размер поля")]), _c('md-select', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.size),
      callback: function($$v) {
        _vm.$set(_vm.property, "size", $$v)
      },
      expression: "property.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("Полноразмерное (100%)")]), _c('md-option', {
    attrs: {
      "value": "80"
    }
  }, [_vm._v("Большое (90%)")]), _c('md-option', {
    attrs: {
      "value": "80"
    }
  }, [_vm._v("Большое (80%)")]), _c('md-option', {
    attrs: {
      "value": "75"
    }
  }, [_vm._v("Большое (75%)")]), _c('md-option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("Среднее (60%)")]), _c('md-option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("Среднее (50%)")]), _c('md-option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("Среднее (40%)")]), _c('md-option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Маленькое (30%)")]), _c('md-option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("Маленькое (25%)")]), _c('md-option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Маленькое (20%)")]), _c('md-option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Маленькое (10%)")])], 1)], 1), _c('div', [((_vm.property.field_type == 'radio') ? true : false) ? _c('md-switch', {
    attrs: {
      "disabled": _vm.sending,
      "disabled": "disabled"
    },
    model: {
      value: (_vm.property.multiply),
      callback: function($$v) {
        _vm.$set(_vm.property, "multiply", $$v)
      },
      expression: "property.multiply"
    }
  }, [_vm._v("Множественное")]) : _vm._e(), ((_vm.property.field_type != 'radio') ? true : false) ? _c('md-switch', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.multiply),
      callback: function($$v) {
        _vm.$set(_vm.property, "multiply", $$v)
      },
      expression: "property.multiply"
    }
  }, [_vm._v("Множественное")]) : _vm._e()], 1), _c('div', [_c('md-switch', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.require),
      callback: function($$v) {
        _vm.$set(_vm.property, "require", $$v)
      },
      expression: "property.require"
    }
  }, [_vm._v("Обязательное")])], 1), _c('div', [_c('md-switch', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.active),
      callback: function($$v) {
        _vm.$set(_vm.property, "active", $$v)
      },
      expression: "property.active"
    }
  }, [_vm._v("Активно")])], 1), _c('div', [_c('md-switch', {
    attrs: {
      "disabled": _vm.sending
    },
    model: {
      value: (_vm.property.default),
      callback: function($$v) {
        _vm.$set(_vm.property, "default", $$v)
      },
      expression: "property.default"
    }
  }, [_vm._v("Является стандартным")])], 1), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.updateProperty()
      }
    }
  }, [_vm._v("Сохранить")]), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "to": {
        name: 'Entity',
        params: {
          code: _vm.$route.params.code,
          entity_code: _vm.$route.params.entity_code
        },
        query: _vm.$route.query
      }
    }
  }, [_vm._v("Отмена")])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4787539d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/Entityproperty.vue
// module id = 1125
// module chunks = 0